import { render, staticRenderFns } from "./GraphicPage.component.pug?vue&type=template&id=8aa39780&scoped=true&lang=pug&"
import script from "./GraphicPage.component.ts?vue&type=script&lang=ts&"
export * from "./GraphicPage.component.ts?vue&type=script&lang=ts&"
import style0 from "./GraphicPage.component.scss?vue&type=style&index=0&id=8aa39780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa39780",
  null
  
)

export default component.exports